import {
  Body,
  Box,
  Button,
  Card,
  CardIcon,
  ContentRow,
  Heading,
  PageHeading,
  Space,
  Stack,
  useIsMobileLayout,
} from "@dbn/omnichannel-design-system-g4p";
import { VirtualCards } from "./VirtualCards";
import { useFormatMessage } from "../intl";
import * as classes from "../Common/OverdraftCard/OverdraftCardDesktop.css";
import { palette } from "@dbn/omnichannel-design-system-g4p/lib/styleConstants";
import { Option } from "fp-ts/Option";
import { useCallback, useEffect, useState } from "react";
import { BackButton } from "../Common/BackButton/BackButton";
import { IO } from "fp-ts/IO";

type Props = {
  onSubmit?: (physicalCardSelected: Option<boolean>) => void;
  physicalCardSelected: Option<boolean>;
  onChange?: (data: any) => void;
  isFromChild?: boolean;
  isCf?: boolean;
  onBack?: IO<unknown>;
  showMastercard: boolean;
};

export const VirtualCardsCommon = (props: Props) => {
  const formatMessage = useFormatMessage();
  const isMobileLayout = useIsMobileLayout();

  const [physicalCardSelected, setPhysicalCardSelected] = useState(
    props.physicalCardSelected
  );

  useEffect(() => {
    if (props.isFromChild) {
      setPhysicalCardSelected(props.physicalCardSelected);
    }
  }, [props.physicalCardSelected]);

  const CardWrapper = useCallback(
    (props: { children: React.ReactElement<unknown> }) => {
      return isMobileLayout ? (
        <>{props.children}</>
      ) : (
        <Card hoverHighlighted>{props.children}</Card>
      );
    },
    [isMobileLayout]
  );

  return (
    <Box column shrink>
      {!props.isCf && (
        <ContentRow type={"full"}>
          <Box grow shrink column hAlignContent="left">
            <PageHeading
              title={formatMessage("UKonto.MainContent.virtualCardStepTitle")}
              description={formatMessage(
                "UKonto.MainContent.virtualCardStepSubtitle"
              )}
              contentRowType={"full"}
            />
          </Box>
        </ContentRow>
      )}

      {/*<ContentRow type={"full"}>*/}
      <Box column shrink>
        <CardWrapper>
          <Box column shrink>
            <Stack units={4} className={classes.heading} vAlignContent="center">
              <CardIcon
                size="large"
                monochromatic
                color={palette.blue800}
                ariaHidden={true}
              />
              <Heading size="small" weight="medium">
                {formatMessage(
                  props.isCf
                    ? "CF.MainContent.virtualCardStep.selectCard"
                    : "UKonto.MainContent.virtualCardStep.selectCard"
                )}
              </Heading>
            </Stack>
            <Space units={4} />
            <Box
              column
              shrink
              className={isMobileLayout ? undefined : classes.content}
            >
              <Body size="medium" weight="regular">
                {formatMessage(
                  "UKonto.MainContent.virtualCardStep.selectCardSubtitle"
                )}
              </Body>
              <Space units={4} />
              <VirtualCards
                showMastercard={props.showMastercard}
                isCf={props.isCf}
                isFromChild={props.isFromChild}
                physicalCardSelected={physicalCardSelected}
                onChange={data => {
                  setPhysicalCardSelected(data.physicalCardSelected);
                  props.onChange && props.onChange(data);
                }}
              />
            </Box>
          </Box>
        </CardWrapper>
      </Box>
      {/*</ContentRow>*/}

      {props.isCf && (
        <Box column>
          <Space units={isMobileLayout ? 4 : 8} />
          {isMobileLayout ? (
            <ContentRow type="1-1">
              <Button
                variant="primary"
                size="default"
                action={() =>
                  props.onSubmit && props.onSubmit(physicalCardSelected)
                }
                label={formatMessage("Next")}
              />
              <BackButton action={() => props.onBack && props.onBack()} />
            </ContentRow>
          ) : (
            <ContentRow type="full" grow>
              <Box grow column={isMobileLayout}>
                <Box>
                  <BackButton action={() => props.onBack && props.onBack()} />
                </Box>
                <Box
                  column
                  grow
                  style={{ alignItems: "end" }}
                  hAlignContent="right"
                >
                  <Button
                    variant="primary"
                    size="default"
                    action={() =>
                      props.onSubmit && props.onSubmit(physicalCardSelected)
                    }
                    label={formatMessage("Next")}
                  />
                </Box>
              </Box>
            </ContentRow>
          )}
        </Box>
      )}
    </Box>
  );
};
